import Vue from 'vue/dist/vue.js';

const auctionCountdown = Vue.component('auction-countdown', {
    delimiters: ['@{','}'],

    template: `<span class="results__item-text">@{ countdownTime }</span>`,

    props : [ 'auction'],

    data: function()
    {
        return {
            countdownTime : null,
            auctionObject : null
        }
    },

    created()
    {
        this.auctionObject = (typeof this.auction === 'string') ? JSON.parse(this.auction) : this.auction;
        setInterval(this.countdown, 1000);
    },

    methods:
    {
        getSchedule()
        {
            let schedule = 'passed';

            if (this.auctionObject) {
                const now = new Date();
                const startDt = new Date(this.auctionObject.sdt);
                const endDt = new Date(this.auctionObject.edt);

                // #1 running
                // startDt is less than now
                // endDt is bigger than now
                if (startDt < now && endDt > now) {
                    schedule = 'running';
                    // #2 pending
                    // startDt is bigger than now
                    // endDt is bigger than now
                } else if (startDt > now && endDt > now) {
                    schedule = 'pending';
                }
            }

            return schedule;
        },

        isAuctionPassed()
        {
            return (this.getSchedule() === 'passed');
        },

        countdown()
        {
            if (!this.isAuctionPassed()) {
                const date = (this.getSchedule() === 'pending') ? this.auctionObject.sdt : this.auctionObject.edt;
                const countDownDate = new Date(date).getTime();

                this.calcTimeDifference(countDownDate);
            }
        },

        calcTimeDifference(countDownDate)
        {
            // Get today's date and time
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            const difference = days + "d " + hours + "t "+ minutes + "min " + seconds + "sek ";

            this.countdownTime = difference;
        },
    }
});

export default auctionCountdown;